import type {ReactElement} from 'react';
import React from 'react';
import {BaseBackgroundColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-background-color-panel';
import {FillTypes} from '@PosterWhiteboard/classes/fill.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromFillOfBackgroundOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromFillOfBackgroundOfActiveItem';
import type {RGBA} from '@Utils/color.util';

export function ItemBackgroundColorPanel(): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const bgFillColor = useGetKeyFromFillOfBackgroundOfActiveItem('fillColor');
  const bgFillType = useGetKeyFromFillOfBackgroundOfActiveItem('fillType');

  if (!activeItem || (activeItem && !('background' in activeItem))) {
    throw new Error('Item does not have background property');
  }

  if (!('fill' in activeItem.background) || !bgFillColor || bgFillType === undefined) {
    throw new Error(`Item doesn't have fill in background property`);
  }

  if (activeItem.background.fill.fillType === FillTypes.NONE) {
    return null;
  }

  const onChangeType = (type: FillTypes): void => {
    void activeItem.updateFromObject({
      background: {
        fill: {
          fillType: type,
          fillColor: activeItem.background.fill.getColorForNewType(type),
        },
      },
    });
  };

  const onChangeColor = (fillColor: RGBA[], undoable = true): void => {
    void activeItem.updateFromObject(
      {
        background: {
          fill: {
            fillColor,
          },
        },
      },
      {undoable}
    );
  };

  return (
    <BaseBackgroundColorPanel
      onChangeType={onChangeType}
      onChangeColor={onChangeColor}
      backgroundFillObject={{
        fillType: bgFillType,
        fillColor: bgFillColor,
      }}
    />
  );
}
